import React from 'react';
import { Link } from 'react-router-dom';
import { Train, Car, MapPin } from 'lucide-react';
import { PRACTICE } from '../../data/practice';
import { SEDATION_AREAS, GETTING_HOME } from '../../data/sedation';

/** Acton W3 is the named location; the ten published areas are named in the body. */
const SedationLocal = ({ local, gettingHome }) => (
  <>
    <section className="container mx-auto px-4 max-w-5xl mt-20 md:mt-28">
      <h2 className="text-2xl md:text-3xl font-semibold text-rabbit">{local.heading}</h2>
      <p className="mt-4 max-w-3xl text-base md:text-lg leading-relaxed text-chocolate-malt">{local.intro}</p>

      <ul className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-testid="sedation-areas">
        {SEDATION_AREAS.map((a) => (
          <li key={a.slug}>
            <Link
              to={`/iv-sedation-${a.slug}`}
              className="group flex items-baseline justify-between gap-3 rounded-xl border border-[#006A71]/12 bg-white px-4 py-3.5 transition-colors duration-200 hover:border-[#01A9B4]/50 hover:bg-[#01A9B4]/[0.04] motion-reduce:transition-none"
              data-testid={`sedation-area-${a.slug}`}
            >
              <span className="text-sm font-medium text-rabbit group-hover:text-[#006A71]">{a.name} <span className="text-chocolate-malt/60">{a.postcode}</span></span>
              <span className="whitespace-nowrap text-xs text-chocolate-malt/70">{a.minutes} min</span>
            </Link>
          </li>
        ))}
      </ul>
      <p className="mt-4 text-sm text-chocolate-malt/75">
        Each area has its own sedation page. Journey times are to Acton, then a 4–9 minute walk from Acton Main Line or Acton Central to {PRACTICE.addressOneLine}.
      </p>
    </section>

    <section className="container mx-auto px-4 max-w-5xl mt-16 md:mt-20">
      <div className="rounded-2xl border border-[#006A71]/15 bg-[#006A71]/[0.035] p-7 sm:p-10">
        <h2 className="text-2xl md:text-3xl font-semibold text-rabbit">{gettingHome.heading}</h2>
        <p className="mt-4 max-w-3xl text-base md:text-lg leading-relaxed text-chocolate-malt">{gettingHome.intro}</p>
        <ul className="mt-7 space-y-4" data-testid="sedation-getting-home">
          {GETTING_HOME.map((point, i) => (
            <li key={point} className="flex gap-4 text-base leading-relaxed text-chocolate-malt">
              <span className="mt-0.5 flex-shrink-0 text-[#006A71]" aria-hidden="true">
                {i === 0 ? <Car className="h-5 w-5" strokeWidth={1.75} /> : i <= 3 ? <Train className="h-5 w-5" strokeWidth={1.75} /> : <MapPin className="h-5 w-5" strokeWidth={1.75} />}
              </span>
              <span>{point}</span>
            </li>
          ))}
        </ul>
        <Link to="/contact" className="mt-7 inline-block text-sm font-semibold text-[#006A71] underline underline-offset-4 hover:text-[#01A9B4]">
          Full directions, map and opening hours
        </Link>
      </div>
    </section>
  </>
);

export default SedationLocal;
